import { Menu } from '@/src/components/ui/Menu'
import { OpacityOverlay } from '../OpacityOverlay'
import { LocationSelectButton } from './LocationSelectButton'
import { LocationSelectMenuList } from './LocationSelectMenuList'
import { useLocationSelect } from './useLocationSelect.hook'

export interface ILocationSelectOption {
  value: number
  label: string
  // TODO - human slop. `original` property will be removed on https://linear.app/ecoplanet/issue/EPR-1047/
  original?: object
}

export interface ILocationHierarchyOption extends ILocationSelectOption {
  menuKey: string
  hierarchy: {
    regionIndex: number
    locationIndex: number
    buildingIndex: number
  }
  showDividerBefore?: boolean
}

export interface ILocationSelectMenuButtonLabels {
  region: string
  location: string
  building: string
}

export const LocationMainSelect = ({ disabled = false }) => {
  const {
    disableSelect,
    showLocationList,
    showBuildingList,
    hoveredRegionIndex,
    hoveredLocationIndex,
    hoveredBuildingIndex,
    selectedRegionIndex,
    selectedLocationIndex,
    selectedBuildingIndex,
    menuButtonLabels,
    activeSearchBoxId,
    regionOptions,
    locationOptions,
    buildingOptions,
    locationSearchTerm,
    buildingSearchTerm,
    regionSearchTerm,
    setActiveSearchBoxId,
    handleRegionChange,
    handleLocationChange,
    handleBuildingChange,
    handleRegionSearch,
    handleLocationSearch,
    handleBuildingSearch,
    handleSubmit,
  } = useLocationSelect()

  return (
    <Menu closeOnSelect={false} placement='bottom-start' flip={true}>
      {({ isOpen }) => {
        return (
          <>
            <LocationSelectButton disabled={disabled || disableSelect} isOpen={isOpen} menuButtonLabels={menuButtonLabels} />

            <LocationSelectMenuList
              isOpen={isOpen}
              activeSearchBoxId={activeSearchBoxId}
              setActiveSearchBoxId={setActiveSearchBoxId}
              onClick={handleSubmit}
              //   regions
              regionOptions={regionOptions}
              hoveredRegionIndex={hoveredRegionIndex}
              selectedRegionIndex={selectedRegionIndex}
              regionSearchTerm={regionSearchTerm}
              handleRegionSearch={handleRegionSearch}
              handleRegionChange={handleRegionChange}
              //   locations
              locationOptions={locationOptions}
              hoveredLocationIndex={hoveredLocationIndex}
              selectedLocationIndex={selectedLocationIndex}
              locationSearchTerm={locationSearchTerm}
              showLocationList={showLocationList}
              handleLocationSearch={handleLocationSearch}
              handleLocationChange={handleLocationChange}
              //   buildings
              buildingOptions={buildingOptions}
              hoveredBuildingIndex={hoveredBuildingIndex}
              selectedBuildingIndex={selectedBuildingIndex}
              buildingSearchTerm={buildingSearchTerm}
              showBuildingList={showBuildingList}
              handleBuildingSearch={handleBuildingSearch}
              handleBuildingChange={handleBuildingChange}
            />

            <OpacityOverlay isOpen={isOpen} />
          </>
        )
      }}
    </Menu>
  )
}
